(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.drawerUtilityLinks = this.querySelector('header-drawer .menu-drawer__utility-links');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      // Seeded synchronously rather than left `{}` until createObserver()'s
      // IntersectionObserver callback lands a frame or more later. While it is
      // `{}`, every `scrollTop > this.headerBounds.bottom` / `<= .top` test in
      // onScroll compares against `undefined` and is therefore false, so a
      // scroll arriving in that window neither adds nor removes
      // `scrolled-past-header`. The shop navbar keys its transparent-over-hero
      // state off that class (assets/shop-nav-figma.css), so it would stay
      // transparent as the page scrolls — white links over light content.
      this.headerBounds = this.header.getBoundingClientRect();

      this.setHeaderHeight();
      document.documentElement.style.setProperty('--utility-links-height', `${this.drawerUtilityLinks.offsetHeight}px`);

      window.matchMedia('(max-width: 999px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      // Mobile collapse bounds (p27): measured rather than hard-coded — the
      // switcher's real bottom edge is ~54-55px, not the 50px min-height. Read
      // here (connect + the 999px mq change) and never on scroll, so the
      // max-height transition always animates between two stable values.
      const bar = this.header.querySelector('.header.header--single-bar');
      if (!bar) return;
      const switcher = bar.querySelector('.header__switcher');
      // scrollHeight, not offsetHeight: the bar clips itself to the value this
      // line writes, so a re-measure while collapsed (or a taller-than-fallback
      // bar) would otherwise lock in the clipped height.
      const barHeight = Math.max(bar.scrollHeight, bar.offsetHeight);
      document.documentElement.style.setProperty('--header-mobile-height', `${barHeight}px`);
      if (switcher) {
        document.documentElement.style.setProperty(
          '--header-switcher-height',
          `${switcher.offsetTop + switcher.offsetHeight}px`
        );
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Drawer open: freeze the mobile row state (and this.currentScrollTop with
      // it) so a scroll behind the overlay can neither collapse nor clip it —
      // the guard also spans the 400ms close animation.
      if (this.querySelector('.menu-drawer-container[open]')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        // headerBounds is a ~zero-height rect, so scrolled-past-header flips on
        // the first pixel — fine for the transparency consumers, too twitchy for
        // the mobile row, which gets its own threshold.
        if (scrollTop > this.headerBounds.bottom + 80) {
          this.header.classList.add('nav-row-collapsed');
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.header.classList.remove('nav-row-collapsed');
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          // Reveal suppressed on purpose (preventHeaderReveal) — the row stays
          // collapsed with the rest of the hidden header.
          this.header.classList.add('nav-row-collapsed');
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header', 'nav-row-collapsed');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  // ------------------------------
  const detailsElements = document.querySelectorAll('header-menu details');

  // Detect touch device
  const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Touch device handling - toggle on tap, close others
  // Desktop hover behavior is handled in details-disclosure.js (HeaderMenu class)
  detailsElements.forEach((details) => {
    const summary = details.querySelector('summary');

    if (isTouchDevice()) {
      // Mobile/touch: toggle open/close on tap
      summary.addEventListener('click', (e) => {
        e.preventDefault();

        const isAlreadyOpen = details.hasAttribute('open');

        // Close all other menus
        detailsElements.forEach((d) => d.removeAttribute('open'));

        // If it was not open, open it (toggle behavior)
        if (!isAlreadyOpen) {
          details.setAttribute('open', '');
        }
      });
    } else {
      // Desktop: hover opens the menu (HeaderMenu class in details-disclosure.js),
      // so a click is normally dead. Generic opt-in (no consumer today): a summary
      // carrying data-summary-href follows that link on a real mouse click;
      // keyboard "clicks" (detail 0) keep the native details toggle so the overlay
      // stays reachable without a pointer.
      summary.addEventListener('click', (e) => {
        const href = summary.dataset.summaryHref;
        if (href && e.detail > 0) {
          e.preventDefault();
          window.location.href = href;
          return;
        }
        if (!href) e.preventDefault();
      });
    }
  });

  // ------------------------------

  $(document).ready(() => {
    const updateHeaderMenuHeight = () => {
      const headerMenuHeight = $('.header > .header__inline-menu').outerHeight();
      if (headerMenuHeight) {
        document.documentElement.style.setProperty('--header-menu-height', `${headerMenuHeight}px`);
      }
    };

    // Run on load
    updateHeaderMenuHeight();

    // Run on resize (debounced for performance)
    let resizeTimeout;
    $(window).on('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateHeaderMenuHeight, 150);
    });

    // Move mega menu content to in-flow panel (under header) when open, back when closed
    const headerWrapper = document.querySelector('.header-wrapper');
    const panel = document.getElementById('mega-menu-panel');
    if (headerWrapper && panel) {
      const moveContentBackToDetails = (content) => {
        const detailsId = content.dataset.detailsId;
        if (detailsId) {
          const details = document.getElementById(detailsId);
          if (details) details.appendChild(content);
          delete content.dataset.detailsId;
        }
      };

      // Keep the columns row on one line. The overlay is title | columns; the
      // title (7.5vw, max 120px) and the gap (7vw, max 120px) scale with the
      // viewport while .mega-menu__content-inner stops at --page-width, and the
      // column widths come from the CMS labels — so at some widths the row
      // overflows and flex-wrap drops the last column under the first one
      // ("Seniors below 1ère équipe"). Measure the deficit and yield it: the
      // gap first (down to its 48px floor), then the title font-size (down to
      // 56px). Below that the row wraps as designed for 990-1200px viewports.
      const MEGA_GAP_MIN = 48;
      const MEGA_TITLE_MIN = 56;
      const fitMegaColumns = (content) => {
        if (!content || !content.isConnected) return;
        content.style.removeProperty('--mega-gap-fit');
        content.style.removeProperty('--mega-title-fit');
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        const inner = content.querySelector('.mega-menu__content-inner');
        const title = content.querySelector('.mega-menu__title');
        const list = content.querySelector('.mega-menu__list--columns');
        if (!inner || !title || !list) return;
        const cols = Array.from(list.children).filter((li) => li.offsetParent !== null);
        if (cols.length < 2) return;
        const wrapped = () => {
          const top = cols[0].getBoundingClientRect().top;
          return cols.some((li) => Math.abs(li.getBoundingClientRect().top - top) > 1);
        };
        const listStyle = getComputedStyle(list);
        const colGap = parseFloat(listStyle.columnGap) || 0;
        const need = cols.reduce((sum, li) => sum + li.getBoundingClientRect().width, 0) + colGap * (cols.length - 1);
        const have = list.clientWidth - (parseFloat(listStyle.paddingLeft) || 0) - (parseFloat(listStyle.paddingRight) || 0);
        let deficit = Math.ceil(need - have);
        if (deficit <= 0 && !wrapped()) return;
        // Sub-pixel column widths round against us when need == have; a 2px
        // margin (retried below while the row still wraps) covers it.
        deficit = Math.max(deficit, 0) + 2;
        const gap = parseFloat(getComputedStyle(inner).columnGap) || 0;
        const titleW = title.getBoundingClientRect().width;
        const fs = parseFloat(getComputedStyle(title).fontSize);
        for (let attempt = 0; attempt < 4; attempt += 1) {
          let left = deficit;
          const gapFit = Math.max(MEGA_GAP_MIN, gap - left);
          if (gapFit < gap) {
            content.style.setProperty('--mega-gap-fit', `${gapFit}px`);
            left -= gap - gapFit;
          }
          if (left > 0 && titleW && fs) {
            const titleFit = Math.max(MEGA_TITLE_MIN, Math.floor(fs * (titleW - left) / titleW));
            if (titleFit < fs) content.style.setProperty('--mega-title-fit', `${titleFit}px`);
            else break;
            if (titleFit === MEGA_TITLE_MIN) break;
          } else if (left > 0) {
            break;
          }
          if (!wrapped()) break;
          deficit += 4;
        }
      };
      const fitOpenMega = () => fitMegaColumns(panel.firstElementChild);
      $(window).on('resize', () => {
        clearTimeout(fitOpenMega.timer);
        fitOpenMega.timer = setTimeout(fitOpenMega, 100);
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitOpenMega);

      const moveContentToPanel = (details) => {
        const content = details.querySelector('.mega-menu__content');
        if (content) {
          content.dataset.detailsId = details.id;
          panel.appendChild(content);
          panel.setAttribute('aria-hidden', 'false');
          fitMegaColumns(content);
        }
      };

      const onMegaMenuOpenChange = (details, isOpen) => {
        if (isOpen) {
          // When opening, swap content: move old out (if any), move new in
          const currentContent = panel.firstElementChild;
          if (currentContent) moveContentBackToDetails(currentContent);
          moveContentToPanel(details);
        } else {
          // When closing, only move content out if NO other menu is open
          // This prevents the panel from becoming empty during menu-to-menu transitions
          const anyMenuOpen = headerWrapper.querySelector('details.mega-menu[open]');
          if (anyMenuOpen) {
            // Another menu is open (or opening), it will handle the content swap
            return;
          }
          const content = panel.firstElementChild;
          if (content && content.dataset.detailsId === details.id) {
            moveContentBackToDetails(content);
          }
          if (!panel.firstElementChild) panel.setAttribute('aria-hidden', 'true');
        }
      };

      const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'open') {
            const details = m.target;
            if (details.classList.contains('mega-menu')) {
              onMegaMenuOpenChange(details, details.hasAttribute('open'));
            }
            break;
          }
        }
      });

      headerWrapper.querySelectorAll('details.mega-menu').forEach((details) => {
        observer.observe(details, { attributes: true });
        // A hover during a slow load can open a menu before this runs; the
        // observer only sees later changes, so move that one in now.
        if (details.hasAttribute('open')) onMegaMenuOpenChange(details, true);
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
